(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arlo-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  // Cross-fades the announcement lines. Mirrors the prototype's timing: the
  // outgoing line holds its is-off state for the length of the CSS transition
  // before the class is cleared, otherwise it snaps back mid-fade.
  class ArloAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.bar__item'));
      if (this.items.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const speed = (parseFloat(this.dataset.speed) || 4.2) * 1000;
      let i = 0;

      this.timer = setInterval(() => {
        const prev = i;
        this.items[prev].classList.replace('is-on', 'is-off');
        i = (i + 1) % this.items.length;
        this.items[i].classList.remove('is-off');
        this.items[i].classList.add('is-on');
        setTimeout(() => this.items[prev].classList.remove('is-off'), 640);
      }, speed);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('arlo-announcement-bar')) {
    customElements.define('arlo-announcement-bar', ArloAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arlo-header"]) return;
  try {
    
  // Transparent over the hero, plated after it. The trigger is the height of
  // the first full-bleed section rather than a fixed offset, so the swap lands
  // as the image leaves rather than at an arbitrary scroll depth.
  class ArloHeader extends HTMLElement {
    connectedCallback() {
      if (this.dataset.overlay !== 'true') return;

      const hero = document.querySelector('.hero');
      this.trigger = hero ? hero.offsetHeight - 120 : 40;
      this.onScroll = () => {
        this.classList.toggle('is-stuck', window.scrollY > this.trigger);
      };

      this.onScroll();
      addEventListener('scroll', this.onScroll, { passive: true });
    }

    disconnectedCallback() {
      removeEventListener('scroll', this.onScroll);
    }
  }

  if (!customElements.get('arlo-header')) {
    customElements.define('arlo-header', ArloHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arlo-launch-story"] && !Shopify.designMode) return;
  try {
    
  const arloSignupReturn = new URL(window.location.href);
  if (arloSignupReturn.searchParams.get('form_type') === 'customer') {
    document.querySelectorAll('form.arlo-signup').forEach(form => {
      if (arloSignupReturn.hash !== '#' + form.id || form.querySelector('[data-arlo-signup-error]')) return;
      const feedback = form.querySelector('[data-arlo-signup-unconfirmed]');
      if (feedback) {
        feedback.hidden = false;
        feedback.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arlo-notify-drawer"]) return;
  try {
    
  class ArloNotifyDrawer extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.dialog = this.querySelector('dialog');
      this.tags = this.querySelector('[data-arlo-notify-tags]');
      this.intro = this.querySelector('[data-arlo-notify-intro]');
      this.defaultIntro = this.intro?.textContent || '';
      // A native modal is above Shopify's CAPTCHA frame. Release its top layer
      // on valid submission so the security challenge can receive clicks/focus.
      // Leave CAPTCHA, native submission and server-confirmed success untouched.
      this.querySelector('form')?.addEventListener('submit', () => {
        if (this.dialog.open) this.dialog.close();
      }, {capture: true, signal: this.abort.signal});
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-arlo-notify]');
        if (trigger) {
          event.preventDefault();
          this.opener = trigger;
          if (this.tags) {
            const tags = ['newsletter', 'waitlist'];
            if (trigger.dataset.arloNotifyCollection) tags.push('waitlist:' + trigger.dataset.arloNotifyCollection);
            if (trigger.dataset.arloNotify) tags.push('waitlist:' + trigger.dataset.arloNotify);
            this.tags.value = [...new Set(tags)].join(',');
          }
          if (this.intro) this.intro.textContent = trigger.dataset.arloNotifyTitle ? 'Join the list for updates on ' + trigger.dataset.arloNotifyTitle + '.' : this.defaultIntro;
          if (!this.dialog.open) this.dialog.showModal();
          this.querySelector('input[type=email]')?.focus();
        }
        if (this.contains(event.target) && event.target.closest('[data-arlo-notify-close]')) this.dialog.close();
      }, {signal:this.abort.signal});
      this.dialog.addEventListener('close', () => this.opener?.focus(), {signal:this.abort.signal});
      const response = this.querySelector('[data-arlo-reopen]');
      const url = new URL(window.location.href);
      const returned = url.hash === '#ArloWaitlist' && url.searchParams.get('form_type') === 'customer';
      if (response || returned) {
        const feedback = response || this.querySelector('[data-arlo-unconfirmed]');
        if (feedback) feedback.hidden = false;
        if (!response && this.tags) {
          const previousTags = (url.searchParams.get('contact[tags]') || '').split(',');
          const trigger = [...document.querySelectorAll('[data-arlo-notify]')].find(button => button.dataset.arloNotify && previousTags.includes('waitlist:' + button.dataset.arloNotify));
          if (trigger) {
            this.opener = trigger;
            this.tags.value = ['newsletter', 'waitlist', trigger.dataset.arloNotifyCollection ? 'waitlist:' + trigger.dataset.arloNotifyCollection : '', 'waitlist:' + trigger.dataset.arloNotify].filter(Boolean).join(',');
            if (this.intro) this.intro.textContent = 'Join the list for updates on ' + trigger.dataset.arloNotifyTitle + '.';
          }
        }
        if (!this.dialog.open) this.dialog.showModal();
        feedback?.focus();
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
  }
  if (!customElements.get('arlo-notify-drawer')) customElements.define('arlo-notify-drawer', ArloNotifyDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
